<template>
    <v-form>
        <v-row>
            <v-col>
                <v-select
                v-model="formData.shipping_provider_id"
                :items="providers"
                label="ผู้จัดส่ง *"
                item-value="id"
                item-text="name"
                outlined
                dense
                :rules="[validators.required]"
                hide-details="auto"
                >
                </v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                v-model="formData.tracking_number"
                label="เลขจัดส่ง *"
                outlined
                dense
                hide-details="auto"
                :rules="[validators.required]"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn
                class="primary"
                :loading="isLoading"
                @click="submitData"
                >ส่งแล้ว</v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>
<script>
import { asyncPost } from '@/helpers/asyncAxios'
import errorParser from '@/plugins/errorparser'
import {
  integerValidator,
  lengthValidator,
  maxLengthValidator,
  maxValueValidator,
  minLengthValidator,
  minValueValidator,
  numberValidator,
  required,
  requiredIf,
} from '@core/utils/validation'
export default {
  props: ['order', 'providers'],
  data() {
    return {
      isLoading: false,
      formData: {
        tracking_number: '',
        shipping_provider_id: null,
      },
      validators: {
        integerValidator,
        lengthValidator,
        maxLengthValidator,
        maxValueValidator,
        minLengthValidator,
        minValueValidator,
        numberValidator,
        required,
        requiredIf,
      },
    }
  },
  methods: {
    async submitData() {
      this.isLoading = true

      try {
        await asyncPost('/saleorder/pendingdelivery/' + this.order.id + '/tiktok/self', this.formData)

        this.$emit('done')
      } catch (error) {
        console.log(error)
        this.$root.showCommonDialog('มีปัญหา', errorParser(error))
      }

      this.isLoading = false
    },
  },
}
</script>
